var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.emptyFields.is
    ? _c(
        "div",
        { staticClass: "emptyFields" },
        [
          _vm._v("\n    Необходимо заполнить поля: \n    "),
          _vm._l(_setup.emptyFields.list, function (f) {
            return _c(
              "a",
              {
                staticClass: "emptyFields__a",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _setup.set_focus(f)
                  },
                },
              },
              [_vm._v(_vm._s(f.title))]
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }